import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { productIdZodSchema } from "@@/shared/products/product-id";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";
import { productFormIdZodSchema } from "../product-form-id";
import { checkboxDataZodObject } from "./data-checkbox";
import { selectDataZodObject } from "./data-select";
import { textDataZodObject } from "./data-textbox";

const productFormMutateCommandZodObject = z.object({
    _id: idZodSchema.default(() =>
        generateId({ prefix: "product_form_mutate_command__" }),
    ),
    _type: z
        .literal("PRODUCT_FORM_MUTATE_COMMAND")
        .default("PRODUCT_FORM_MUTATE_COMMAND"),
    _createdAt: isoAndUnixZodSchema.default(() => nowIsoAndUnix()),
    productFormId: productFormIdZodSchema,
    productId: productIdZodSchema,
    fields: z.array(
        z.discriminatedUnion("fieldType", [
            checkboxDataZodObject,
            textDataZodObject,
            selectDataZodObject,
        ]),
    ),
});
type ProductFormMutateCommand = z.infer<
    typeof productFormMutateCommandZodObject
>;

const factoryParamsZodObject = productFormMutateCommandZodObject.omit({
    _id: true,
    _type: true,
    _createdAt: true,
});
type FactoryParams = z.infer<typeof factoryParamsZodObject>;

const productFormMutateCommandFactory = (
    params: FactoryParams,
): ProductFormMutateCommand => {
    return productFormMutateCommandZodObject.parse({
        ...params,
        _id: generateId({ prefix: "product_form_mutate_command__" }),
        _type: "PRODUCT_FORM_MUTATE_COMMAND",
        _createdAt: nowIsoAndUnix(),
    });
};
export {
    productFormMutateCommandFactory,
    factoryParamsZodObject as productFormMutateCommandFactoryParamsZodObject,
    productFormMutateCommandZodObject,
};
export type {
    ProductFormMutateCommand,
    FactoryParams as ProductFormMutateCommandFactoryParams,
};
